import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box, CssBaseline } from '@mui/material';
import Sidebar from './components/Sidebar';
import TrainingScenarios from './components/TrainingScenarios';
import Settings from './components/Settings';
import ChatBox from './components/ChatBox';
import Practice from './components/Practice';
import EnglishPractice from './components/EnglishPractice';
import { AvatarProvider } from './contexts/AvatarContext';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import OCRFlowchart from './components/OCRFlowchart';
import MockConversation from './components/MockConversation';
import History from './components/History';
import POCEvaluationForm from './components/POCEvaluationForm';
import POCEvaluationResults from './components/POCEvaluationResults';
import FeedbackResults from './components/FeedbackResults';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/ProtectedRoute';
import ChatEvaluation from './components/ChatEvaluation';
import EvaluationList from './components/EvaluationList';
import EvaluationDetail from './components/EvaluationDetail';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#f0f2f5',
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <AvatarProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Box sx={{ display: 'flex' }}>
              <Sidebar />
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  width: { sm: `calc(100% - ${250}px)` },
                  ml: { sm: `${250}px` },
                  backgroundColor: '#f0f2f5',
                  minHeight: '100vh',
                  pb: 10,
                }}
              >
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/" element={
                    <ProtectedRoute>
                      <TrainingScenarios />
                    </ProtectedRoute>
                  } />
                  <Route path="/scenarios" element={
                    <ProtectedRoute>
                      <TrainingScenarios />
                    </ProtectedRoute>
                  } />
                  <Route path="/practice" element={
                    <ProtectedRoute>
                      <Practice />
                    </ProtectedRoute>
                  } />
                  <Route path="/english-practice" element={
                    <ProtectedRoute>
                      <EnglishPractice />
                    </ProtectedRoute>
                  } />
                  <Route path="/history" element={
                    <ProtectedRoute>
                      <History />
                    </ProtectedRoute>
                  } />
                  <Route path="/settings" element={
                    <ProtectedRoute>
                      <Settings />
                    </ProtectedRoute>
                  } />
                  <Route path="/chat/:scenarioId" element={
                    <ProtectedRoute>
                      <ChatBox />
                    </ProtectedRoute>
                  } />
                  <Route path="/ocr-flowchart" element={
                    <ProtectedRoute>
                      <OCRFlowchart />
                    </ProtectedRoute>
                  } />
                  <Route path="/mock-conversation" element={
                    <ProtectedRoute>
                      <MockConversation />
                    </ProtectedRoute>
                  } />
                  <Route path="/poc-evaluation" element={
                    <ProtectedRoute>
                      <POCEvaluationForm />
                    </ProtectedRoute>
                  } />
                  <Route path="/poc-evaluation-form" element={
                    <ProtectedRoute>
                      <POCEvaluationForm />
                    </ProtectedRoute>
                  } />
                  <Route path="/poc-evaluation-results" element={
                    <ProtectedRoute>
                      <POCEvaluationResults />
                    </ProtectedRoute>
                  } />
                  <Route path="/feedback-results" element={
                    <ProtectedRoute>
                      <FeedbackResults />
                    </ProtectedRoute>
                  } />
                  <Route path="/chat-evaluation/:conversationId" element={
                    <ProtectedRoute>
                      <ChatEvaluation />
                    </ProtectedRoute>
                  } />
                  <Route path="/evaluations" element={
                    <ProtectedRoute>
                      <EvaluationList />
                    </ProtectedRoute>
                  } />
                  <Route path="/evaluations/:evaluationId" element={
                    <ProtectedRoute>
                      <EvaluationDetail />
                    </ProtectedRoute>
                  } />
                </Routes>
              </Box>
            </Box>
          </Router>
        </ThemeProvider>
      </AvatarProvider>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
